// extracted by mini-css-extract-plugin
export default {"wrapper":"TableRow_wrapper__fnetO","subTableRow":"TableRow_subTableRow__FUcCz"};